import staticURL from 'lib/staticURL';

import type {ScientificModelCardProps} from './ScientificModelCard';

// `onButtonClick` is intentionally omitted here; it is supplied by the renderer so the
// "Configure" button can open the Boltz API configuration modal.
export const BOLTZ_API_CARD_PROPS: Pick<
  ScientificModelCardProps,
  | 'systemName'
  | 'displayName'
  | 'iconPath'
  | 'description'
  | 'paperLink'
  | 'inputTypes'
  | 'category'
  | 'buttonLabel'
> = {
  systemName: 'boltz_api',
  displayName: 'Boltz API',
  iconPath: staticURL('/static/img/model_hub/boltz2.png'),
  description: 'Access new models from the Boltz API using Benchling credits.',
  paperLink: '',
  inputTypes: ['amino_acid_sequence', 'molecule'],
  category: 'structure_prediction',
  buttonLabel: 'Configure',
};
